interface AvatarProps {
  photoUrl: string | null
  initial: string
  /** Matches Home greeting strip by default. */
  size?: 'sm' | 'md' | 'lg'
}

const SIZE_CLASS: Record<NonNullable<AvatarProps['size']>, string> = {
  sm: 'h-10 w-10 rounded-xl text-base',
  md: 'w-12 h-12 rounded-2xl text-lg',
  lg: 'w-16 h-16 rounded-2xl text-xl',
}

/**
 * Telegram profile photo when available; otherwise a branded initial tile
 * (same treatment as HomeScreen).
 */
export function Avatar({ photoUrl, initial, size = 'md' }: AvatarProps) {
  const dim = SIZE_CLASS[size]
  if (photoUrl) {
    return (
      <img
        src={photoUrl}
        alt=""
        className={`${dim} object-cover border-2 border-brand-border`}
      />
    )
  }
  return (
    <div
      aria-hidden
      className={`${dim} bg-brand-primary-strong text-brand-on-primary font-semibold flex items-center justify-center shadow-brand`}
    >
      {initial}
    </div>
  )
}
